import { TextResourceService } from '../../services/text-resource.service';
import { BaseComponent } from '../base/base.component';
import packageInfo from '../../../../../../package.json';
import { environment } from '../../../environments/environment';
import { Component, OnInit, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgTemplateOutlet } from '@angular/common';

@Component({
    // tslint:disable-next-line: component-selector
    selector: '[app-header]',
    templateUrl: './header.component.html',
    imports: [RouterLink, NgTemplateOutlet]
})
export class HeaderComponent extends BaseComponent implements OnInit {
  @Input() logo = 'assets/images/logo-cibg.svg';
  @Input() smallScreenLogo = 'assets/images/fallback-beeldmerk.svg';

  version: string;

  constructor(
    textResourceService: TextResourceService) {
    super(textResourceService, 'HeaderComponent');
  }

  ngOnInit() {
    if (!environment.production) {
      this.version = packageInfo.version;
    }
  }
}
